import { c as _c } from "react/compiler-runtime";
import { useMetadata } from './use-metadata';
import { useAppLocale } from './use-app-locale';

/**
 * Hook to build translated route paths from metadata
 * @returns Object with getRoute and buildRoute functions
 * @example
 * const { getRoute, buildRoute } = useTranslatedRoute()
 * getRoute('products') // => urunler (tr-TR)
 * buildRoute('products', 'engine') // => /urunler/engine (tr-TR)
 * buildRoute('corporate/videos') // => /kurumsal/videolar (tr-TR)
 * buildRoute('corporate/videos', 'video-1') // => /kurumsal/videolar/video-1 (tr-TR)
 */
export const useTranslatedRoute = () => {
  const $ = _c(9);
  const {
    routeParams
  } = useMetadata();
  const {
    backendLocale
  } = useAppLocale();
  let t0;
  if ($[0] !== backendLocale || $[1] !== routeParams) {
    t0 = routePath => {
      if (routeParams[routePath]?.[backendLocale]) {
        return routeParams[routePath][backendLocale];
      }
      return routePath;
    };
    $[0] = backendLocale;
    $[1] = routeParams;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const getRoute = t0;
  let t1;
  if ($[3] !== backendLocale || $[4] !== routeParams) {
    t1 = (path, ...t2) => {
      const params = t2;
      const segments = path.split("/").filter(Boolean);
      const translatedSegments = segments.map(segment => {
        if (routeParams[segment]?.[backendLocale]) {
          return routeParams[segment][backendLocale];
        }
        return segment;
      });
      const allSegments = [...translatedSegments, ...params.filter(Boolean)];
      return "/" + allSegments.join("/");
    };
    $[3] = backendLocale;
    $[4] = routeParams;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const buildRoute = t1;
  let t2;
  if ($[6] !== buildRoute || $[7] !== getRoute) {
    t2 = {
      getRoute,
      buildRoute
    };
    $[6] = buildRoute;
    $[7] = getRoute;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export default useTranslatedRoute;